import { useEffect, useState } from "react";
import { getRealTimeClients, handleDownloadReport } from "../services";
import moment from "moment";
import { manageDownloadDocument } from "../../../../util/download-file";
import * as Yup from "yup";

export const useRealTimeReport = () => {
  const [clients, setClients] = useState([]);
  const [clientSelected, setClientSelected] = useState(null);
  const [practices, setPractices] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  const createValidationSchema = () =>
    Yup.object().shape({
      startDate: Yup.date().required("Start Date is required"),
      endDate: Yup.date()
        .min(Yup.ref("startDate"), "End date cannot be before start date")
        .required("End Date is required"),
      idClient: Yup.object({
        value: Yup.string().required("Client value is required"),
        label: Yup.string().required("Client label is required"),
      })
        .nullable()
        .required("Select a client"),
      /* clinicId: Yup.object({
        value: Yup.string().required("Practice value is required"),
        label: Yup.string().required("Practice label is required"),
      })
        .nullable()
        .required("Select an practice"),*/
    });

  /* useEffect(() => {
    if (clientSelected) updatePracticesWhenClientSelectedChange();
  }, [clientSelected]);*/

  useEffect(() => {
    getClients();
  }, []);

  /* function updatePracticesWhenClientSelectedChange() {
    const client = clients.find((item) => item._id === clientSelected.value);

    if (!client) {
      setPractices([]);
      return;
    }

    setPractices(
      client.clinics.map((practice) => {
        return { value: practice._id, label: practice.clinicName };
      }),
    );
  }*/

  async function getClients() {
    await getRealTimeClients().then(([status, data]) => {
      if (!status) {
        setClients([]);
        return;
      }
      setClients(data);
    });
  }

  async function handleSubmit(values) {
    setIsDownloading(true);
    const request = {
      dateStart: moment(values.startDate).format("YYYY-MM-DD"),
      dateEnd: moment(values.endDate).format("YYYY-MM-DD"),
      idClient: values.idClient.value,
    };

    await handleDownloadReport(request).then(([status, response]) => {
      if (!status) {
        setIsDownloading(false);
        return;
      }

      downloadFile(response, values.idClient);
      setTimeout(() => {
        setClientSelected(null);
        setIsDownloading(false);
      }, 1000);
    });
  }

  function downloadFile(response, clientSelected) {
    manageDownloadDocument(
      `${clientSelected.label || ""}_${moment().format("DD-MM-YYYY HH:mm:ss")}`,
      response,
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    );
  }

  return {
    clients,
    clientSelected,
    setClientSelected,
    practices,
    handleSubmit,
    isDownloading,
    createValidationSchema,
  };
};
